import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const images = [
  `${process.env.PUBLIC_URL}/hero1.jpg`,
  `${process.env.PUBLIC_URL}/hero2.jpg`,
  `${process.env.PUBLIC_URL}/hero3.jpg`,
  `${process.env.PUBLIC_URL}/hero4.jpg`,
  `${process.env.PUBLIC_URL}/hero5.webp`,
  `${process.env.PUBLIC_URL}/hero6.jpg`,
  `${process.env.PUBLIC_URL}/hero7.jpg`,
  `${process.env.PUBLIC_URL}/hero8.jpg`,
  `${process.env.PUBLIC_URL}/hero9.jpg`,
  `${process.env.PUBLIC_URL}/hero10.jpg`,
  `${process.env.PUBLIC_URL}/hero11.jpg`,
];

const Hero = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [fadeIn, setFadeIn] = useState({
    logo: false,
    heading: false,
    subheading: false,
  });

  useEffect(() => {
    // Cycle through images every 8 seconds
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 8000);

    // Handle fade-in animations
    const timer1 = setTimeout(
      () => setFadeIn((prev) => ({ ...prev, logo: true })),
      600
    );
    const timer2 = setTimeout(
      () => setFadeIn((prev) => ({ ...prev, heading: true })),
      1100
    );
    const timer3 = setTimeout(
      () => setFadeIn((prev) => ({ ...prev, subheading: true })),
      1600
    );

    return () => {
      clearInterval(interval);
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, []);

  return (
    <div className="relative w-full h-[60vh] overflow-hidden">
      {images.map((image, index) => (
        <motion.div
          key={index}
          className="absolute inset-0 w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: `url(${image})`,
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: currentImageIndex === index ? 1 : 0 }}
          transition={{ duration: 1, ease: "easeInOut" }}
        />
      ))}

      <div className="flex flex-col items-center relative z-10 h-full justify-center">
        {/* Black Shadow Layer for Logo */}
        <motion.img
          src={`${process.env.PUBLIC_URL}/ImperiumLogo.png`}
          alt="Logo shadow"
          initial={{ opacity: 0 }}
          animate={{ opacity: fadeIn.logo ? 1 : 0 }}
          transition={{ duration: 1 }}
          className="absolute mb-4 w-1/2 filter brightness-0 opacity-80 blur-md z-[-1]" // Shadow behind logo
          aria-hidden="true"
        />

        {/* Main Logo */}
        <motion.img
          src={`${process.env.PUBLIC_URL}/ImperiumLogo.png`}
          alt="Imperium Auto Group Logo"
          initial={{ opacity: 0 }}
          animate={{ opacity: fadeIn.logo ? 1 : 0 }}
          transition={{ duration: 1 }}
          className="relative mb-4 w-1/2"
        />

        {/* Headings with Combined Backdrop */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: fadeIn.heading ? 1 : 0 }}
          transition={{ duration: 1 }}
          className="relative px-6 py-4 text-center max-w-4xl mx-auto"
        >
          {/* Black Shadow Layer for Heading */}
          <motion.h1
            style={{ color: "#ffffff" }}
            initial={{ opacity: 0 }}
            animate={{ opacity: fadeIn.heading ? 1 : 0 }}
            transition={{ duration: 1 }}
            className="absolute inset-0 text-3xl md:text-4xl font-bold italic lilita-one-regular filter brightness-0 opacity-80 blur-md z-[-1]" // Shadow for heading
            aria-hidden="true"
          >
            Automotive Excellence
          </motion.h1>

          {/* Main Heading */}
          <motion.h1
            style={{ color: "#ffffff" }}
            initial={{ opacity: 0 }}
            animate={{ opacity: fadeIn.heading ? 1 : 0 }}
            transition={{ duration: 1 }}
            className="text-3xl md:text-4xl font-bold italic lilita-one-regular relative"
          >
            Automotive Excellence
          </motion.h1>

          {/* Black Shadow Layer for Subheading */}
          <motion.h2
            initial={{ opacity: 0 }}
            animate={{ opacity: fadeIn.subheading ? 1 : 0 }}
            transition={{ duration: 1 }}
            className="absolute inset-0 text-2xl md:text-3xl font-bold filter brightness-0 opacity-80 blur-md z-[-1]" // Shadow for subheading
            aria-hidden="true"
          >
            Quality used vehicle parts & spares.
          </motion.h2>

          {/* Main Subheading */}
          <motion.h2
            initial={{ opacity: 0 }}
            animate={{ opacity: fadeIn.subheading ? 1 : 0 }}
            transition={{ duration: 1 }}
            className="text-2xl md:text-3xl font-bold text-white font-coolfont mt-2 relative"
          >
            Quality used vehicle parts & spares.
          </motion.h2>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
